import { FETCH_REQUEST, INBOX } from "utils/reducers";

// Action type interfaces

interface SetSearchQueryAction {
  type: typeof INBOX.search_inbox;
  payload: string;
}

interface RequestSentAction {
  type: typeof FETCH_REQUEST.sent;
  payload: string;
}

interface RequestSuccessAction {
  type: typeof FETCH_REQUEST.success;
  payload: any; // TODO: define a more specific type for requestDetails
}

interface RequestFailureAction {
  type: typeof FETCH_REQUEST.failure;
  payload: Error | string;
}

// Union type for all actions
export type ActionTypes =
  | SetSearchQueryAction
  | RequestSentAction
  | RequestSuccessAction
  | RequestFailureAction;

// Action creators
export const setSearchQuery = (query: string): SetSearchQueryAction => ({
  type: INBOX.search_inbox,
  payload: query,
});

export const requestSent = (requestID: string): RequestSentAction => ({
  type: FETCH_REQUEST.sent,
  payload: requestID,
});

export const requestSuccess = (requestDetails: any): RequestSuccessAction => ({
  type: FETCH_REQUEST.success,
  payload: requestDetails,
});

export const requestFailure = (
  error: Error | string
): RequestFailureAction => ({
  type: FETCH_REQUEST.failure,
  payload: error,
});
